module.exports = __webpack_public_path__ + "img/xiaozi_yigong.1eae8bbd.jpg";